import { render, staticRenderFns } from "./InformacionQueja.vue?vue&type=template&id=152a1185&scoped=true"
import script from "./InformacionQueja.vue?vue&type=script&lang=js"
export * from "./InformacionQueja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a1185",
  null
  
)

export default component.exports